export default __webpack_public_path__ + "static/media/playerPlay24.fc93a882.svg";